class TranslationsResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { gatewayApi }) {
        return (headers = {}) =>
            $resource(
                `${gatewayApi.url}/v1/sales/:id`,
                { id: "@id" },
                {
                    getConfig: {
                        method: "GET",
                        url: `${gatewayApi.url}/v1/configuration`
                    },
                    postSaleTranslations: {
                        method: "POST",
                        url: `${gatewayApi.url}/v1/sales/:id/translate`,
                        headers
                    }
                }
            );
    }
}

angular.module("thor.core.translations.resource", []).factory("translationsResource", TranslationsResource);
